export default __webpack_public_path__ + "static/media/CoCo.adfc1d4f.gif";